// Import SCSS
import '../sass/style.scss';
import './vendor/headroom';

import sideMenu from './components/sideMenu';
import callToAction from './components/callToAction';
import domContentLoaded from './utils/domContentLoaded';

const header = document.querySelector('.site-header');

// Initialize scripts
domContentLoaded(() => {
  if (header) {
    const headroom = new Headroom(header, { // eslint-disable-line
      offset: 157,
    });
    headroom.init();
    if (header.classList.contains('headroom')) {
      document.body.classList.add('header-is-sticky');
    }
  }
  sideMenu.init();
  callToAction();
});

(function initialize() {
  const museLetter = document.getElementById('newsletter-toggle');
  if (! museLetter) {
    return;
  }

  const signupForm = document.querySelector('.newsletter-form');
  if (null === signupForm) {
    return;
  }

  const readComments = document.querySelectorAll('.read-comments');
  if (null === readComments) {
    return;
  }

  for (let i = 0; i < readComments.length; i += 1) {
    readComments[i].onclick = () => {
      this.classList.toggle('open');
      this.nextElementSibling.classList.toggle('show');
    };
  }

  museLetter.onclick = () => {
    signupForm.classList.toggle('show-form');
  };
}());

if (module.hot) {
  if (header) {
    const headroom = new Headroom(header, { // eslint-disable-line
      offset: 157,
    });
    headroom.init();
    if (header.classList.contains('headroom')) {
      document.body.classList.add('header-is-sticky');
    }
  }
  sideMenu.init();
  callToAction();
  module.hot.accept();
}
